import React, { useState } from "react";
import axios from "./axiosConfig";

export default function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [step, setStep] = useState("email");
  const [message, setMessage] = useState("");

  const sendCode = async () => {
    try {
      await axios.post("/api/request-code", { email });
      setStep("code");
      setMessage("✅ Code sent to your email");
    } catch {
      setMessage("❌ Failed to send code");
    }
  };

  const verifyCode = async () => {
    try {
      const res = await axios.post("/api/verify-code", { email, code });
      localStorage.setItem("jwt_token", res.data.access_token);
      axios.defaults.headers.common["Authorization"] = `Bearer ${res.data.access_token}`; // ✅ inject token
      onLogin?.();
    } catch {
      setMessage("❌ Invalid code");
    }
  };

  return (
    <div className="mx-auto w-full max-w-md rounded-lg border border-slate-200 bg-white p-6 shadow-sm dark:border-slate-700 dark:bg-slate-900">
      <h2 className="mb-4 text-xl font-bold text-slate-900 dark:text-white">Login</h2>

      {step === "email" ? (
        <>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            className="mb-4 w-full rounded border border-slate-300 bg-white p-2 text-slate-900 placeholder:text-slate-400 dark:border-slate-600 dark:bg-slate-950 dark:text-slate-100"
          />
          <button
            type="button"
            onClick={sendCode}
            className="w-full rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700 dark:bg-blue-600 dark:hover:bg-blue-500"
          >
            Send Code
          </button>
        </>
      ) : (
        <>
          <input
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="Enter the code"
            className="mb-4 w-full rounded border border-slate-300 bg-white p-2 text-slate-900 placeholder:text-slate-400 dark:border-slate-600 dark:bg-slate-950 dark:text-slate-100"
          />
          <button
            type="button"
            onClick={verifyCode}
            className="w-full rounded bg-emerald-600 px-4 py-2 text-white hover:bg-emerald-700 dark:bg-emerald-600 dark:hover:bg-emerald-500"
          >
            Verify
          </button>
        </>
      )}

      {message && (
        <p className="mt-4 text-sm text-slate-600 dark:text-slate-400">{message}</p>
      )}
    </div>
  );
}
